(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const slides = [...root.querySelectorAll('[data-slide]')];
      const dots = [...root.querySelectorAll('[data-dot]')];
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const speed = Number(root.dataset.speed) || 5000;
      const autoplay = root.dataset.autoplay === 'true';
      const infinite = root.dataset.infinite !== 'false';
      const pauseHover = root.dataset.pauseHover === 'true';
      const show = (nextIndex, userInitiated = false) => {
        if (!infinite && (nextIndex < 0 || nextIndex >= slides.length)) return;
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        if (userInitiated) restart();
      };
      const restart = () => {
        clearTimeout(timer);
        root.classList.remove('is-running');
        void root.offsetWidth;
        if (autoplay) {
          root.style.setProperty('--ph-progress-duration', `${speed}ms`);
          root.classList.add('is-running');
          timer = setTimeout(() => show(index + 1), speed);
        }
      };
      prev?.addEventListener('click', () => show(index - 1, true));
      next?.addEventListener('click', () => show(index + 1, true));
      dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.dot), true)));
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1, true); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1, true); }
      });
      if (pauseHover) {
        root.addEventListener('mouseenter', () => clearTimeout(timer));
        root.addEventListener('mouseleave', restart);
      }
      root.tabIndex = 0;
      show(0);
      restart();
    };
    const boot = () => document.querySelectorAll('[data-premium-hero]').forEach(init);
    document.addEventListener('DOMContentLoaded', boot, { once: true });
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-premium-hero]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
